import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ListItem from '../index';
import { defaultUserPhoto } from '../../../../../constants/ui';

export default class ListItemContact extends PureComponent {
  render () {
    const { user } = this.props;

    return (
      <ListItem link={`employers/${user.id}`}>
        <div className={`col col-sm-6 col-lg-3 d-flex align-items-center`}>
          <div style={{ backgroundImage: `url('${user.photo_image_url || defaultUserPhoto}')` }} className='avatar-sm' />
          <div>
            <div className='text-ellipsis text-md text-medium'>{user.first_name} {user.last_name}</div>
            <div className='list-item-label'>Name</div>
          </div>
        </div>
        <div className={`col col-sm-6 col-lg-3`}>
          <div className='text-ellipsis'>{user.email}</div>
          <div className='list-item-label'>Email</div>
        </div>
        <div className={`col col-sm-6 col-lg-2`}>
          <div className='text-ellipsis'>{user.phone}</div>
          <div className='list-item-label'>Phone</div>
        </div>
        <div className='col col-sm-6 col-lg-3'>
          <div className='text-ellipsis'>{user.company_name}</div>
          <div className='list-item-label'>Company</div>
        </div>
        <div className={`col col-sm-6 col-lg-1`}>
          <div className='button button-badge button-primary'>{user.id}</div>
        </div>
      </ListItem>
    );
  }
}

ListItemContact.propTypes = {
  user: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/common/lists/ListItem/ListItemContact/index.js